import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "header__breadcrumbs" }
const _hoisted_2 = { class: "multiselect__option__name" }
const _hoisted_3 = {
  key: 5,
  type: "button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbsProjectsBlock = _resolveComponent("BreadcrumbsProjectsBlock")!
  const _component_BreadcrumbsMyWorkBlock = _resolveComponent("BreadcrumbsMyWorkBlock")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TeamSelectionDropdown = _resolveComponent("TeamSelectionDropdown")!
  const _component_BreadcrumbsTeamsBlock = _resolveComponent("BreadcrumbsTeamsBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.displayProjectsBlock && _ctx.$route.params.projectId)
      ? (_openBlock(), _createBlock(_component_BreadcrumbsProjectsBlock, {
          key: 0,
          selectedProject: _ctx.selectedProject,
          onOnTeamClick: _ctx.onTeamClick
        }, null, 8, ["selectedProject", "onOnTeamClick"]))
      : _createCommentVNode("", true),
    (_ctx.breadcrumbsMyWorkBlock)
      ? (_openBlock(), _createBlock(_component_BreadcrumbsMyWorkBlock, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.displayTeamSelectionBlock)
      ? (_openBlock(), _createBlock(_component_TeamSelectionDropdown, {
          key: 2,
          selectedTeam: _ctx.selectedTeam,
          teams: _ctx.teams,
          className: "team-selection team-selection-breadcrumb"
        }, {
          singleLabel: _withCtx(({ option }) => [
            _createVNode(_component_BaseSubHeading, {
              size: "large",
              weight: "400",
              color: "monochrome-05",
              className: "header__breadcrumb"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" /"),
                _createElementVNode("span", null, _toDisplayString(option.name), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          option: _withCtx(({ option }) => [
            (_ctx.selectedProject.urlName)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {
            params: {
              teamId: option.urlName,
              projectId: _ctx.selectedProject.urlName
            },
            name: _ctx.meta?.navigateToByTeamBreadcrumbs as string
          },
                  class: "team-selection-breadcrumb__option"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Avatar, {
                      src: option.picture?.pictureUrl || null,
                      size: "sm",
                      class: "multiselect__option__avatar",
                      type: "teamsGroup"
                    }, null, 8, ["src"]),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(option.name), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["selectedTeam", "teams"]))
      : (_ctx.displayTeamNavigationBlock)
        ? (_openBlock(), _createBlock(_component_BreadcrumbsTeamsBlock, {
            key: 3,
            teams: _ctx.teams,
            onOnMenuItemClick: _ctx.onSprintSelected
          }, null, 8, ["teams", "onOnMenuItemClick"]))
        : (_ctx.selectedTeam?.name && !_ctx.$route?.meta?.hideTeamSection && _ctx.canShowTeamList)
          ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
              key: 4,
              size: "large",
              weight: "400",
              color: "monochrome-05",
              className: "header__breadcrumb"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" /"),
                _createElementVNode("span", null, _toDisplayString(_ctx.selectedTeam.name), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
    (_ctx.sprintLabel)
      ? (_openBlock(), _createElementBlock("button", _hoisted_3, [
          _createVNode(_component_BaseSubHeading, {
            size: "large",
            weight: "400",
            color: "monochrome-05",
            className: "header__breadcrumb"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" /"),
              _createElementVNode("span", null, _toDisplayString(_ctx.sprintLabel), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbConfigList, (breadcrumbConfig, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (
          !_ctx.isBreadcrumbTitleWaiting(breadcrumbConfig) &&
          (_ctx.breadcrumbLink(breadcrumbConfig) || _ctx.breadcrumbTitle(breadcrumbConfig))
        )
          ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
              key: 0,
              size: "large",
              weight: "400",
              color: "monochrome-05",
              className: "header__breadcrumb"
            }, {
              default: _withCtx(() => [
                (_ctx.breadcrumbLink(breadcrumbConfig))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("/"),
                      _createVNode(_component_router_link, {
                        to: _ctx.breadcrumbLink(breadcrumbConfig)?.route
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.breadcrumbLink(breadcrumbConfig)?.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("/"),
                      _createElementVNode("span", null, _toDisplayString(_ctx.breadcrumbTitle(breadcrumbConfig)), 1)
                    ], 64))
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.breadcrumbComponent(breadcrumbConfig))))
      ], 64))
    }), 128))
  ]))
}